import { atom } from 'nanostores';
import type { Command } from '~/lib/shell/driver';
import { ShellDriver } from '~/lib/shell/driver';
import { hmrPropertyFactory } from '~/utils/hmr';

const hmr = hmrPropertyFactory('TerminalStore');

export class TerminalStore {
  @hmr()
  showTerminal = atom(false);

  terminalDriver: ShellDriver;

  constructor() {
    this.terminalDriver = new ShellDriver();
  }

  toggleTerminal(value?: boolean) {
    this.showTerminal.set(value !== undefined ? value : !this.showTerminal.get());
  }

  processCommand(command: Command) {
    this.terminalDriver.processCommand(command);
  }
}
